export default "__VITE_ASSET__CKl8eCiE__"